export default class FooterAccess {
    constructor() {
        this.familyTrigger = document.querySelector("[data-family-trigger]");
        this.familyDropdown = document.querySelector("[data-family-dropdown]");
        this.familyIsOpen = false;

        this.catalogTrigger = document.querySelector("[data-catalog-trigger]");
        this.catalogDropdown = document.querySelector(
            "[data-catalog-dropdown]"
        );
        this.catalogIsOpen = false;

        if (this.familyTrigger && this.familyDropdown) {
            this.bindFamilyEvents();
        }

        if (this.catalogTrigger && this.catalogDropdown) {
            this.bindCatalogEvents();
        }
    }

    bindFamilyEvents() {
        // Toggle dropdown
        this.familyTrigger.addEventListener("click", (e) => {
            e.stopPropagation();
            this.toggleFamily();
        });

        // Close on outside click
        document.addEventListener("click", (e) => {
            if (
                this.familyIsOpen &&
                !this.familyDropdown.contains(e.target) &&
                !this.familyTrigger.contains(e.target)
            ) {
                this.closeFamily();
            }
        });

        // Close on ESC key
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.familyIsOpen) {
                this.closeFamily();
            }
        });
    }

    bindCatalogEvents() {
        // Toggle dropdown
        this.catalogTrigger.addEventListener("click", (e) => {
            e.stopPropagation();
            this.toggleCatalog();
        });

        // Close on outside click
        document.addEventListener("click", (e) => {
            if (
                this.catalogIsOpen &&
                !this.catalogDropdown.contains(e.target) &&
                !this.catalogTrigger.contains(e.target)
            ) {
                this.closeCatalog();
            }
        });

        // Close on ESC key
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.catalogIsOpen) {
                this.closeCatalog();
            }
        });

        // Close family dropdown when catalog opens
        this.catalogTrigger.addEventListener("click", () => {
            if (this.familyIsOpen) {
                this.closeFamily();
            }
        });
    }

    toggleFamily() {
        if (this.familyIsOpen) {
            this.closeFamily();
        } else {
            this.openFamily();
        }
    }

    openFamily() {
        this.familyDropdown.classList.add("is-open");
        this.familyTrigger.classList.add("is-active");
        this.familyIsOpen = true;
        // Close catalog if open
        if (this.catalogIsOpen) {
            this.closeCatalog();
        }
    }

    closeFamily() {
        this.familyDropdown.classList.remove("is-open");
        this.familyTrigger.classList.remove("is-active");
        this.familyIsOpen = false;
    }

    toggleCatalog() {
        if (this.catalogIsOpen) {
            this.closeCatalog();
        } else {
            this.openCatalog();
        }
    }

    openCatalog() {
        this.catalogDropdown.classList.add("is-open");
        this.catalogTrigger.classList.add("is-active");
        this.catalogIsOpen = true;
        // Close family if open
        if (this.familyIsOpen) {
            this.closeFamily();
        }
    }

    closeCatalog() {
        this.catalogDropdown.classList.remove("is-open");
        this.catalogTrigger.classList.remove("is-active");
        this.catalogIsOpen = false;
    }
}
